import { zoneActivityCapabilities } from '../../config/zoneActivityCapabilities';
import { DeviceSettings } from '../../config/DeviceSettings';

import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { theme } from '../../theme/theme';

import { Icon } from '../common/Icon';
import { ZoneActivityPulse } from '../zone/ZoneActivityPulse';

import { iconWarningCircle } from '../../theme/icons/interface/warning-circle/warning-circle';

export function IndicatorAlarmSpecific({ device, capabilityId }) {
  const [value] = useCapabilityValue({
    deviceId: device.id,
    capabilityId,
  });

  if (value !== true) return null;

  const isZoneActivityCapability = zoneActivityCapabilities.has(capabilityId);

  if (!device.settings[DeviceSettings.ZoneActivityDisabled] && isZoneActivityCapability) {
    return <ZoneActivityPulse />;
  }

  return <Icon display="block" url={iconWarningCircle} color={theme.color.yellow} size="20px" />;
}
